import React, { useState } from "react";
import MasonryGallery from "../components/MasonryGallery";
import { visibleItems, CATEGORY_ORDER, CATEGORY_DESCRIPTIONS } from "../data";

const ALL = "All";

export default function PortfolioPage() {
  const [active, setActive] = useState(ALL);

  const filtered =
    active === ALL
      ? visibleItems
      : visibleItems.filter(
          (i) => i.categories && i.categories.includes(active)
        );

  return (
    <div className="portfolio-page">
      <div className="container">
        <header className="portfolio-page__header fade-up">
          <h1 className="portfolio-page__heading">Portfolio<span style={{ color: "var(--c-teal)" }}>.</span></h1>
          <p className="portfolio-page__sub">{CATEGORY_DESCRIPTIONS[active]}</p>
        </header>

        <div
          className="portfolio-page__filters fade-up"
          style={{ animationDelay: "0.1s" }}
        >
          {CATEGORY_ORDER.map((cat) => (
            <button
              key={cat}
              className={`filter-pill${
                active === cat ? " filter-pill--active" : ""
              }${cat === "All" ? " filter-pill--all" : ""}`}
              onClick={() => setActive(cat)}
            >
              {cat}
            </button>
          ))}
        </div>

        <MasonryGallery allItems={visibleItems} filteredItems={filtered} />
      </div>
    </div>
  );
}
